import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectUserId, selectWork, selectWorks } from '../../../../Api/selectors';
import styled from 'styled-components';
import {
  INTERIOR_PREVIEW_VALUES,
  EXTERIOR_PREVIEW_VALUES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_TASKS,
} from '../../../constants';
import { VBox, HBox } from '../../../../../components/Box';
import { VehicleInfoCard } from '../../../components/CardInfo';
import { VehicleDataCard } from '../../../components/CardData';
import { VehicleFinanceSalesCard } from '../../../components/CardFinanceSales';
import { VehicleCardCounters } from '../../../components/CardCounters';
import { VehicleFinancePurchaseCard } from '../../../components/CardFinancePurchase';
import { VehicleDocumentsCard } from '../../../components/CardDocuments';
import { VehicleLocationCard } from '../../../components/VehicleLocationCard';
import { Card } from '../../../../../components/Card';
import { Button } from '../../../../../components/Buttons';
import { VehicleBpmCard } from '../../../components/CardBPM';
import { Slider } from '../../../components/Slider';
import { VehicleDataConsumptionCard } from '../../../components/ConsumptionEnviromentData';
import { VehicleRDWandHistoryDataCard } from '../../../components/RDWandHistoryCard';
import { VehicleLabelCard } from '../../../components/CardLabel';
import { VehicleTransportCard } from '../../../components/CardTransport';
//import { VehicleHooicardtakeout } from '../components/cardHooicardtakeout';

import { VehicleExtraCostCard } from '../../../components/CardExtraCost';
import { Check, IsOpen } from '../../../../../components/Icon';
import { VehicleOutgoingInvoiceCard } from '../../../components/CardOutgoingInvoice';
import {
  deleteVehicle,
  deleteVehicleProperty,
  downloadImages,
  fetchVehicle,
  fetchVehicleTasks,
  setVehicleProperty,
} from '../../../actions';
import { VehicleWebsiteCard } from '../../../components/CardWebsite';
import { VehicleInspectionCard } from '../../../components/VehicleInspectionCard';
import { Loader } from '../../../../../components/Loader';
import { VehicleTasksCard } from '../../../components/CardVehicleTasks';
import { VehicleInvoicesCard } from '../../../components/VehcleInvoicesCard';
import { fetchVehicleInvoices } from '../../../../Invoices/actions';
import { REQUEST_VEHICLE_INVOICES } from '../../../../Invoices/constants';
//import { VehicleHooiInstallationPhotoCard } from '../components/CardHooiInstallationPhotos';
import { VehicleRemarksCard } from '../../../components/CardVehicleRemarks';
import env from '../../../../../env';
import { VehicleClaimCard } from '../../../components/CardClaim';
import { Permission } from '../../../../../components/Permission';
import {
  VEHICLE_REMOVE,
  VEHICLE_EDIT,
  VEHICLE_INVOICES_BUTTON,
  VEHICLE_DETAILS_BUTTON,
  VEHICLE_DOWNLOAD_IMAGES,
  VEHICLE_ACTIONS_BUTTON,
  VEHICLE_HEXON_BUTTON,
  VEHICLE_TAKEN_BUTTON,
  VEHICLE_LOGS,
  VEHICLE_EXTRA_COSTS_CRUD,
  VEHICLE_TRANSPORT_CRUD,
  VEHICLE_INSPECTION_CRUD,
  VEHICLE_DOCUMENTS_CRUD,
  PURCHASING_DATA_CRUD,
  SALES_DATA_CRUD,
  INVOICES_PAGE,
} from '../../../../../components/Permission/constants';
import { VehicleOptionsCard } from '../../../components/VehicleOptionsCard';
import { PdfPreview } from '../../../components/PriceCardPDF/PdfPreview';
import { SaleAgreementPdfPreview } from '../../../components/SaleAgreement/SaleAgreementPdfPreview';
import LoadingDetailsPageCard from '../../../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import cn from 'classnames';
import styles from './detailsColumns.module.css';
import { VehicleProductTasksSection } from '../../../components/VehicleProductTasksSection';
import { VehicleOutgoingProductInvoiceCard } from '../../../components/CardProductOutgoingInvoice';
import { VehicleTasksRemarksCard } from '../../../components/CardVehicleTasksRemarks';
import LoadingCard from '../../../../../containers/App/Components/LoadingCard/LoadingCard';

//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card.wide {
    width: 99%;
  }

  .info-card-fin {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card-fin.wide {
    width: 99%;
  }

  .vehicle-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox .toggleBtn {
    margin-left: auto;
    width: 12%;
  }

  .slider-block {
    background-color: #fff;
    width: 100%;
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    border: 0px solid #dbdcdc;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07);
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;
const STATE = {
  previewType: 'interior',
  isShowExsterior: true,
  isShow: true,
  loading: false,
  IsOpen: false,
  showSaleAgreementPdfPreview: false,
};

class VehicleDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  componentDidMount() {
    this.timeout(() => this.setState({ showOutgoingInvoiceCard: true }), 1500);
    this.timeout(() => this.setState({ loadSliderAfterTimeout: true }), 800);
    this.timeout(this.props.fetchVehicleTasks, 2000);
    this.setOutgoingProductInvoiceCardData();
  }

  setOutgoingProductInvoiceCardData() {
    this.props.fetchVehicleInvoices(result => {
      if (result?.items?.length > 0) {
        console.log('Fetched Invoices:', result.items);

        const outgoingProductInvoices = result.items.filter(invoice => {
          const isOutgoing = invoice?.direction === 'outgoing';
          const isProduct = invoice?.subjectType === 'product';
          const isNotFinal = !invoice?.isFinal;

          console.log(
            `Invoice ID: ${invoice.id}, isOutgoing: ${isOutgoing}, isProduct: ${isProduct}, isNotFinal: ${isNotFinal}`,
          );

          return isOutgoing && isProduct && isNotFinal;
        });
        console.log('outgoingProductInvoices', outgoingProductInvoices);
        console.log('Filtered outgoing product invoices:', outgoingProductInvoices);

        if (outgoingProductInvoices.length > 0) {
          const lastCreatedOutgoingProductId = outgoingProductInvoices[0]?.id;
          this.setState({ outgoingProductInvoiceId: lastCreatedOutgoingProductId });
        }
      }
    });
  }

  hideBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, previewType: 'exterior', isShow: val, loading: false }));
  }

  hideExteriorBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, isShowExsterior: val, loading: false }));
  }

  handleDelete = () => {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (!confirm('delete vehicle?')) return;
    this.props.deleteVehicle(result => {
      if (result) {
        console.log(result, 'RES');
        return this.to('/');
      }
    });
  };

  downloadImages() {
    this.setState({ downloadingImages: true }, () => {
      this.props.downloadImages(result => {
        this.setState({ downloadingImages: false });
        window.open('/storage/zip/tmp/' + this.props.vehicle.id + '.zip');
      });
    });
  }

  renderProductInvoiceCard() {
    if (this.props.workInvoices) return <Loader small />;

    return (
      <VehicleOutgoingProductInvoiceCard
        vehicleId={this.props.vehicle.id}
        vehicle={this.props.vehicle}
        invoiceId={this.state.outgoingProductInvoiceId}
      />
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const params = new URLSearchParams(window.location.search);
    const showLinktree = params.get('showLinkTree') === 'yes' || window.innerWidth <= 768;

    // if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.containerPage}>
        {this.state.showPdfPreview && (
          <PdfPreview onClose={() => this.setState({ showPdfPreview: false })} vehicle={vehicle} />
        )}
        {this.state.showSaleAgreementPdfPreview && (
          <SaleAgreementPdfPreview onClose={() => this.setState({ showSaleAgreementPdfPreview: false })} vehicle={vehicle} />
        )}
        <VBox left className={cn('col', styles.firstColumn)} top>
          {showLinktree && (
            <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
              <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
              <div className={styles.containerButton}>
                <Permission permission={VEHICLE_EDIT}>
                  {vehicle.task_test_drive == '0' && vehicle.state_ac == null ? (
                    <Button
                      className={styles.buttonDelete}
                      warning
                      onClick={() => {
                        if (window.confirm('Weet je het zeker?')) {
                          this.props.setValueTestDriveAllClear('1');
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.no_testdrive_task')}
                    </Button>
                  ) : vehicle.state_ac == !null ? (
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.testdrive_allready done')}
                    </Button>
                  ) : (
                    <Button
                      className={styles.button}
                      onClick={() => {
                        if (window.confirm('Weet je het zeker?')) {
                          this.props.setValueTestDriveAllClear('1');
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.testdrive_all_clear')}
                    </Button>
                  )}

                  {vehicle.location_address_id == '5' ? (
                    <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('13584')}>
                      {this.lbl('vehicle.linktree.zet_naar_lippestraat')}
                    </Button>
                  ) : vehicle.location_address_id == '13584' ? (
                    <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('5')}>
                      {this.lbl('vehicle.linktree.zet_naar_kleefstraat')}
                    </Button>
                  ) : (
                    <>
                      <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('13584')}>
                        {this.lbl('vehicle.linktree.zet_naar_lippestraat')}
                      </Button>
                      <Button className={styles.button} onClick={() => this.props.setValueLocationAddress('5')}>
                        {this.lbl('vehicle.linktree.zet_naar_kleefstraat')}
                      </Button>
                    </>
                  )}

                  {vehicle.transport_outgoing_assigned_to != null && vehicle.transport_outgoing_done == null ? (
                    <Button
                      className={styles.button}
                      onClick={() => {
                        if (window.confirm('Are you sure?')) {
                          this.props.setValueTransportOutgoing();
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.transport_outgoing_done')}
                    </Button>
                  ) : vehicle.transport_outgoing_assigned_to == null ? (
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.transport_outgoing_not_planned')}
                    </Button>
                  ) : vehicle.transport_outgoing_done === '1' ? (
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.transport_is_allready_done')}
                    </Button>
                  ) : null}
                  {vehicle.vehicle_purpose == 'commercial' && vehicle.import == '1' && !vehicle.task_popnagels ? (
                    <Button
                      className={styles.button}
                      onClick={() => {
                        if (window.confirm('Popnagels afronden en €15 kosten opvoeren?')) {
                          this.props.setValuePopnagels();
                        }
                      }}
                    >
                      {this.lbl('vehicle.linktree.popnagels_afronden')}
                    </Button>
                  ) : vehicle.task_popnagels == '1' ? (
                    <Button className={styles.buttonDelete} warning>
                      {this.lbl('vehicle.linktree.popnagels_afgerond')}
                    </Button>
                  ) : null}
                </Permission>
              </div>
            </Card>
          )}
          <VehicleInfoCard vehicle={this.props.vehicle} />

          <VehicleDataCard vehicle={this.props.vehicle} />
          <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
          <VehicleRDWandHistoryDataCard vehicle={this.props.vehicle} />
          <Permission permission={INVOICES_PAGE}>
            {this.state.showOutgoingInvoiceCard ? <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} /> : null}
          </Permission>
          {window.innerWidth <= 768 && (
            <>
              <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
              {this.props.workTask ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleTasksCard vehicle={this.props.vehicle} onAdded={this.setOutgoingProductInvoiceCardData.bind(this)} />
              )}
              <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
              {/* <VehicleProductTasksSection
                vehicleId={this.props.vehicle?.id}
                onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
              /> */}
              <VehicleBpmCard vehicle={this.props.vehicle} />
              <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              </Permission>
              {this.props.workRemarks ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              )}
              {this.props.workVehicle ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
              )}
              <VehicleWebsiteCard vehicle={this.props.vehicle} />
              <VehicleCardCounters vehicle={this.props.vehicle} />
              <VehicleClaimCard vehicle={this.props.vehicle} />
              <VehicleLabelCard vehicle={this.props.vehicle} />
            </>
          )}
        </VBox>
        <VBox left className="col" top style={{ flex: '0 0 50%' }}>
          {this.state.outgoingProductInvoiceId && this.renderProductInvoiceCard()}
          {window.innerWidth > 768 && (
            <Wrapper>
              <VBox top>
                <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
                <VehicleBpmCard vehicle={this.props.vehicle} />
                <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                  <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                </Permission>
                {this.props.workTask ? (
                  <LoadingDetailsPageCard detailsCard />
                ) : (
                  <VehicleTasksCard
                    vehicle={this.props.vehicle}
                    onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                  />
                )}

                <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
                {/* <VehicleProductTasksSection
                  vehicleId={this.props.vehicle?.id}
                  onAdded={this.setOutgoingProductInvoiceCardData.bind(this)}
                /> */}
                {this.props.workRemarks ? (
                  <LoadingDetailsPageCard />
                ) : (
                  <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
                )}
              </VBox>
              <VBox top>
                {this.props.workVehicle ? (
                  <LoadingDetailsPageCard />
                ) : (
                  <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
                )}
                <VehicleCardCounters vehicle={this.props.vehicle} />
                <VehicleLabelCard vehicle={this.props.vehicle} />
                <VehicleWebsiteCard vehicle={this.props.vehicle} />
                <VehicleClaimCard vehicle={this.props.vehicle} />
                <Permission permission={VEHICLE_TRANSPORT_CRUD}>
                  <VehicleTransportCard vehicle={this.props.vehicle} />
                </Permission>
              </VBox>
            </Wrapper>
          )}
          <VehicleOptionsCard vehicle={this.props.vehicle} />
          {window.innerWidth <= 768 && (
            <Card className={cn('vehicle-info-card info-card data', styles.card)}>
              <HBox>
                <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.finance.purchase.photos')}</h2>
                <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                  <IsOpen />
                </div>
              </HBox>
              {this.state.isOpen && (
                <>
                  {(this.state.isShow || this.state.isShowExsterior) && (
                    <VBox className="slider-block" center>
                      <Button
                        className="toggleBtn"
                        onClick={() =>
                          this.state.previewType === 'exterior'
                            ? this.setState({ previewType: 'interior' })
                            : this.setState({ previewType: 'exterior' })
                        }
                      >
                        {this.state.previewType === 'exterior' ? 'Interior' : 'Exterior'}
                      </Button>
                      {this.state.previewType === 'exterior' && this.state.isShowExsterior && (
                        <Slider
                          hideExteriorBlock={this.hideExteriorBlock.bind(this)}
                          vehicleId={this.vehicle.id}
                          type={this.state.previewType}
                          helga_id={this.vehicle.helga_id}
                          spinValues={EXTERIOR_PREVIEW_VALUES}
                        />
                      )}
                      {this.state.previewType === 'interior' && this.state.isShow && (
                        <Slider
                          hideBlock={this.hideBlock.bind(this)}
                          vehicleId={this.vehicle.id}
                          type={this.state.previewType}
                          helga_id={this.vehicle.helga_id}
                          spinValues={INTERIOR_PREVIEW_VALUES}
                        />
                      )}
                    </VBox>
                  )}
                </>
              )}
            </Card>
          )}

          {this.state.loadSliderAfterTimeout ? (
            <>
              {(this.state.isShow || this.state.isShowExsterior) && window.innerWidth > 768 && (
                <VBox className="slider-block" center>
                  <Button
                    className="toggleBtn"
                    onClick={() =>
                      this.state.previewType === 'exterior'
                        ? this.setState({ previewType: 'interior' })
                        : this.setState({ previewType: 'exterior' })
                    }
                  >
                    {this.state.previewType === 'exterior' ? 'Interior' : 'Exterior'}
                  </Button>
                  {this.state.previewType === 'exterior' && this.state.isShowExsterior && (
                    <Slider
                      hideExteriorBlock={this.hideExteriorBlock.bind(this)}
                      vehicleId={this.vehicle.id}
                      type={this.state.previewType}
                      helga_id={this.vehicle.helga_id}
                      spinValues={EXTERIOR_PREVIEW_VALUES}
                    />
                  )}
                  {this.state.previewType === 'interior' && this.state.isShow && (
                    <Slider
                      hideBlock={this.hideBlock.bind(this)}
                      vehicleId={this.vehicle.id}
                      type={this.state.previewType}
                      helga_id={this.vehicle.helga_id}
                      spinValues={INTERIOR_PREVIEW_VALUES}
                    />
                  )}
                </VBox>
              )}
            </>
          ) : null}
          <Permission permission={VEHICLE_INSPECTION_CRUD}>
            <VehicleInspectionCard vehicle={this.props.vehicle} />
          </Permission>
          <VehicleInvoicesCard vehicle={this.props.vehicle} />
        </VBox>

        <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
          {window.innerWidth <= 768 && (
            <Permission permission={VEHICLE_TRANSPORT_CRUD}>
              <VehicleTransportCard vehicle={this.props.vehicle} />
            </Permission>
          )}
          <Permission permission={VEHICLE_DOCUMENTS_CRUD}>
            <VehicleDocumentsCard vehicle={this.props.vehicle} />
          </Permission>
          <VehicleLocationCard vehicle={this.props.vehicle} vehicle_details />
          <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
            <h2 className="card-title mb-2 text-muted">other</h2>
            <div className={styles.containerButton}>
              <Permission permission={VEHICLE_EDIT}>
                <Button className={styles.buttonEdit} primary onClick={this.tofn(`/vehicles/${this.vehicle.id}/edit`)}>
                  {this.lbl('edit')}
                </Button>
              </Permission>
              <Button
                onClick={() => {
                  this.setState({ showPdfPreview: true });
                }}
              >
                {this.lbl('vehicle.details.options.pricecard')}
              </Button>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>
                {this.lbl('vehicle.details.columns.title')}
              </Button>
              {vehicle.status !== '3' ? (
                <Button
                  className={styles.button}
                  onClick={() => window.open(`https://indewal.nl/vindat/vehicles/${this.vehicle.id}`)}
                >
                  Inspectie rapport
                </Button>
              ) : (
                <Button
                  className={styles.button}
                  onClick={() =>
                    window.open(`https://indewal.nl/vindat/vehicles/${this.vehicle.id}?token=${vehicle.creditor_company}`)
                  }
                >
                  Inspectie rapport
                </Button>
              )}
              {vehicle.status !== '3' ? (
                <Button
                  className={styles.button}
                  onClick={() => window.open(`https://indewal.nl/vindat/vehicles/${this.vehicle.id}?version1`)}
                >
                  Inspectie rapport V1
                </Button>
              ) : (
                <Button
                  className={styles.button}
                  onClick={() =>
                    window.open(
                      `https://indewal.nl/vindat/vehicles/${this.vehicle.id}?version1&token=${vehicle.creditor_company}`,
                    )
                  }
                >
                  Inspectie rapport V1
                </Button>
              )}
              <Button
                onClick={() => {
                  this.setState({ showSaleAgreementPdfPreview: true });
                }}
              >
                {this.lbl('vehicle.details.sale_agreement.generate_sale_agreement')}
              </Button>
              <Permission permission={VEHICLE_DETAILS_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/legacy`)}>
                  {this.lbl('vehicle.details.title')}
                </Button>
              </Permission>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/options`)}>
                {this.lbl('vehicle.details.options.title')}
              </Button>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/documents`)}>
                {this.lbl('vehicle.details.documents.title')}
              </Button>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/price`)}>
                {this.lbl('vehicle.details.price.title')}
              </Button>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/supplier`)}>
                {this.lbl('vehicle.details.supplier.title')}
              </Button>
              <Permission permission={VEHICLE_INVOICES_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/invoices`)}>
                  {this.lbl('vehicle.details.invoices.title')}
                </Button>
              </Permission>
              <Permission permission={VEHICLE_ACTIONS_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/actions`)}>
                  actions
                </Button>
              </Permission>
              <Permission permission={VEHICLE_TAKEN_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/state`)}>
                  Taken
                </Button>
              </Permission>
              <Permission permission={VEHICLE_HEXON_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/hexon`)}>
                  Hexon
                </Button>
              </Permission>
              <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/silverdat`)}>
                Silverdat
              </Button>
              <Permission permission={VEHICLE_DOWNLOAD_IMAGES}>
                <Button
                  className={styles.button}
                  disabled={this.state.downloadingImages}
                  onClick={this.downloadImages.bind(this)}
                >
                  {this.state.downloadingImages ? <Loader small /> : null} {this.lbl('vehicle.download-images')}
                </Button>
              </Permission>
              <Permission permission={VEHICLE_LOGS}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/history`)}>
                  Logs
                </Button>
              </Permission>
              {env.enable_hemex ? <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/hemex`)}>Hemex</Button> : null}

              {env.vehicle_details_show_special_button ? (
                <Button
                  className={styles.button}
                  active={this.vehicle.special_customer}
                  onClick={() => {
                    this.props.setVehicleProperty('special_customer', this.vehicle.special_customer == '1' ? null : '1');
                  }}
                >
                  {this.vehicle.special_customer ? <Check /> : null}&nbsp;Special customer
                </Button>
              ) : null}

              <Permission permission={VEHICLE_REMOVE}>
                <Button className={styles.buttonDelete} warning onClick={this.handleDelete}>
                  Delete
                </Button>
              </Permission>
            </div>
          </Card>
        </VBox>
      </Container>
    );
  }
}

VehicleDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //  work: selectWorks([REQUEST_VEHICLE_INVOICES]),
    workVehicle: selectWork(REQUEST_VEHICLE),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`),
    loggedInUserId: selectUserId(),
    workTaskRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-taskRemarks`),
    workTask: selectWork(REQUEST_VEHICLE_TASKS),
    //creditorCompany: selectCompany(getPropByName(ownProps.vehicle, 'creditor_company')),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setVehicleProperty(name, value, callback) {
      if (value === null || value === undefined) {
        dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
      } else {
        dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
      }
    },
    deleteVehicle(callback) {
      dispatch(deleteVehicle(ownProps.vehicle.id, callback));
    },
    downloadImages(callback) {
      dispatch(downloadImages(ownProps.vehicle.id, callback));
    },
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id));
    },
    fetchVehicleTasks(callback) {
      dispatch(fetchVehicleTasks(ownProps.vehicle?.id, callback));
    },
    setValueLocationAddress(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_address_id', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_company_id', '4'));
      // window.location.reload();
    },
    setValueTransportOutgoing() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_initiated', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_done', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_assigned_to', null));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_completed_date', 'date_today'));
      // window.location.reload();
    },
    setValuePopnagels() {
      let extra_cost_popnagels_sum = Number(ownProps.vehicle?.extra_cost_popnagels) + 15;
      let extra_cost_sum = Number(ownProps.vehicle?.extra_cost_sum) + 15;
      let extra_cost_economic_prize_sum = Number(ownProps.vehicle?.economic_prize) + 15;

      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_popnagels', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_popnagels', extra_cost_popnagels_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_sum', extra_cost_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'economic_prize', extra_cost_economic_prize_sum));
    },
    setValueTestDriveAllClear(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_engine_general', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_ac', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_brakes', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_transmission', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_electrics', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive', '0'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsColumns = compose(withConnect, withRouter)(VehicleDetailsColumnsComp);
